import CodeBlock from '@tiptap/extension-code-block'
import { ReactNodeViewRenderer } from '@tiptap/react'
import { MermaidNodeView } from '../MermaidNodeView'
import { CodeBlockNodeView } from '../CodeBlockNodeView'

export const MermaidCodeBlock = CodeBlock.extend({
  addNodeView() {
    return ({ node, ...rest }) => {
      if (node.attrs.language === 'mermaid') {
        return ReactNodeViewRenderer(MermaidNodeView)({ node, ...rest })
      }
      return ReactNodeViewRenderer(CodeBlockNodeView)({ node, ...rest })
    }
  },
})
